var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _path0, _line3, _path1, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #45413c;\n        opacity: 0.15;\n      }\n\n      .cls-2,\n      .cls-5 {\n        fill: #debb7e;\n      }\n\n      .cls-2,\n      .cls-6,\n      .cls-9 {\n        stroke: #45413c;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        fill: #f0d5a8;\n      }\n\n      .cls-4 {\n        fill: #f7e5c6;\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: #ffe500;\n      }\n\n      .cls-8 {\n        fill: #ebcb00;\n      }\n\n      .cls-9 {\n        fill: #ff6242;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "544-pizza-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "_Ellipse_",
    "data-name": "<Ellipse>",
    className: "cls-1",
    cx: 24,
    cy: 42.5,
    rx: 13.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-2",
    d: "M40.21,26.6,40.49,28s-11,3.86-16.25,5c-6,1.27-15.56,2.13-18.72,2.57a3.88,3.88,0,0,1-3.93-2l-.49-.87,38.84-7.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-3",
    d: "M40.21,26.6l-.46-2.43c-.7-3.72-9-8.13-19-7.11,0,0-1.9-3.42,1-4.6s23.92-5.17,24.7,10.83a2.44,2.44,0,0,1-2,2.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M21.81,12.46c-1.91.77-1.76,2.49-1.43,3.59a2.69,2.69,0,0,1,1.16-.83c2.83-1.15,22.7-4.94,24.58,9.47a2.34,2.34,0,0,0,.39-1.4C45.73,7.29,24.73,11.28,21.81,12.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-5",
    d: "M40.21,26.6l4.29-.82a2.44,2.44,0,0,0,2-2.49,14.47,14.47,0,0,0-.73-4,5,5,0,0,0-2.58-.16c-2.35.44-4,2.3-3.62,4.14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-6",
    d: "M40.21,26.6l4.29-.82a2.44,2.44,0,0,0,2-2.49,14.47,14.47,0,0,0-.73-4,5,5,0,0,0-2.58-.16c-2.35.44-4,2.3-3.62,4.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    className: "cls-6",
    d: "M40.21,26.6l-.46-2.43c-.7-3.72-9-8.13-19-7.11,0,0-1.9-3.42,1-4.6s23.92-5.17,24.7,10.83a2.44,2.44,0,0,1-2,2.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    className: "cls-7",
    d: "M20.79,17.06l-19.27,14A1.25,1.25,0,0,0,1,32.3l.08.44.46,2.43a1.24,1.24,0,0,0,1.45,1,1.22,1.22,0,0,0,1-1.44l-.23-1.22,3.65-.69.34,1.83a1.86,1.86,0,0,0,3.65-.69l-.35-1.83,17-3.22.23,1.22a1.24,1.24,0,0,0,1.45,1,1.22,1.22,0,0,0,1-1.44l-.23-1.22,6.08-1.15.34,1.83a1.86,1.86,0,0,0,3.65-.69l-.81-4.25C39.05,20.45,30.77,16,20.79,17.06Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    className: "cls-8",
    d: "M36.57,27.28l.34,1.83a1.86,1.86,0,0,0,3.65-.69l-.81-4.25c-.7-3.72-9-8.13-19-7.11l-1.09.79c8.22.25,14.58,4,15.19,7.23l.46,2.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M6.34,31a.51.51,0,0,1-.49-.41.5.5,0,0,1,.4-.58l30.37-5.75a.5.5,0,1,1,.19,1L6.43,31Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "_Line_",
    "data-name": "<Line>",
    className: "cls-6",
    x1: 30.49,
    y1: 28.43,
    x2: 30.26,
    y2: 27.22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "_Line_2",
    "data-name": "<Line>",
    className: "cls-6",
    x1: 36.57,
    y1: 27.28,
    x2: 36.11,
    y2: 24.85
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    className: "cls-6",
    d: "M20.79,17.06l-19.27,14A1.25,1.25,0,0,0,1,32.3l.54,2.87a1.24,1.24,0,0,0,1.45,1,1.22,1.22,0,0,0,1-1.44l-.23-1.22,3.65-.69.34,1.83a1.86,1.86,0,0,0,3.65-.69l-.35-1.83,17-3.22.23,1.22a1.24,1.24,0,0,0,1.45,1,1.22,1.22,0,0,0,1-1.44l-.23-1.22,6.08-1.15.34,1.83a1.86,1.86,0,0,0,3.65-.69l-.81-4.25C39.05,20.45,30.77,16,20.79,17.06Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "_Line_3",
    "data-name": "<Line>",
    className: "cls-6",
    x1: 7.41,
    y1: 32.8,
    x2: 7.18,
    y2: 31.59
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M18.18,23.21c2.35-.44,4.05-1.89,3.79-3.23-.18-1-1.33-1.6-2.83-1.73l-5.4,3.93C14.42,23.13,16.21,23.59,18.18,23.21Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M34.3,25.2a1.74,1.74,0,0,0,.36-1.33c-.25-1.34-2.36-2.07-4.71-1.63s-4,1.9-3.79,3.24a1.76,1.76,0,0,0,.82,1.1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M10,29.79a1.74,1.74,0,0,0,.35-1.32c-.18-1-1.36-1.63-2.89-1.73L2.11,30.63a2,2,0,0,0,.58.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_13",
    "data-name": "<Path>",
    className: "cls-9",
    d: "M23.86,27.17c-.71-1.3-2.87-2-5.22-1.53S14.53,27.5,14.34,29Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.0a4d5942668339da00ff3903ef8db371.svg";
export { ForwardRef as ReactComponent };